import { Visit } from '../../../common/types/Visit';

export const filterIdsFromVisit = (filteredGuestIds: string[]) => (
  visit: Visit
) =>
  filteredGuestIds.length > 0
    ? visit.guestIds.some(guestId => filteredGuestIds.includes(guestId))
    : true;
